
import React from 'react'
import {
  Link
} from 'react-router-dom'
import InputRow from './InputRow'
import PropTypes from 'prop-types'
import { emailCheck, pwdCheck } from '../constants'
import submit from '../submit.gif'
import logo from '../logo.gif'
export default class LoginPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      pwd: '',
      error: '',
      errorColor: 'red',
      processing: false,
      resetProcessing: false,
     // isActive:true   
    }
    this.handleLogin = this.handleLogin.bind(this)
    this.resetPassword = this.resetPassword.bind(this)
  }

  componentDidMount () {
    const id = sessionStorage.getItem('id')
    const token = sessionStorage.getItem('token')
    if (id && token) {
      const { history } = this.props
      history.replace('/')
    }
  }

  async handleLogin () {
    this.setState({ processing: true })
    const { email, pwd } = this.state
    if (email && pwd) {
      if (emailCheck.test(email)) {
        if (pwdCheck.test(pwd)) {
          fetch(`${process.env.REACT_APP_API_URL}/api/login/UserLogin`, {
            method: 'POST',
            body: JSON.stringify({
              Email: email,
              Password: pwd
            }),
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(res => res.json())
            .then(res => {
              if (res.StatusCode === 200) {
                this.setState({ processing: false })
                sessionStorage.setItem('token', res.Data.Token)
                sessionStorage.setItem('id', res.Data.IncompleteApplicationId)
                const currentDate = new Date()
                currentDate.setSeconds(currentDate.getSeconds() + 3600000)
                sessionStorage.setItem('expiry', currentDate)
                sessionStorage.setItem('email', email)
                sessionStorage.setItem('isBlocking', false)
                this.props.onLogin(email, res.Data.IncompleteApplicationId, res.Data.Token)
                const { history } = this.props
                history.replace('/')
              } else {
                this.setState({ error: res.Msg, processing: false, errorColor: 'red', pwd: '' })
              }
            })
            .catch((err) => {
              this.setState({ error: 'Network Error', processing: false, pwd: '' })
              console.log(err)
            })
        } else {
          this.setState(
            {
              error: 'Please Enter a password which at least has 1 character and 1 number with a minimum length of 8 and maximum of 15.',
              errorColor: 'red',
              processing: false,
              pwd: ''
            }
          )
        }
      } else {
        this.setState(
          {
            error: 'Please Enter a Valid Email Address',
            errorColor: 'red',
            processing: false,
            pwd: ''
          }
        )
      }
    } else {
      this.setState(
        {
          error: 'Please fill up all required fields',
          errorColor: 'red',
          processing: false,
          pwd: ''
        }
      )
    }
  }

  resetPassword () {
    this.setState({ resetProcessing: true })
    const { email } = this.state
    if (email) {
      if (emailCheck.test(email)) {
        fetch(`${process.env.REACT_APP_API_URL}/api/Login/ResetPassword`, {
          method: 'POST',
          body: JSON.stringify({
            email: email
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then((res) => res.json())
          .then(res => {
            if (res.StatusCode === 200) {
              this.setState({ resetProcessing: false })
              this.setState(
                {
                  error: 'You would have received an E-mail with your new password',
                  errorColor: 'green',
                  pwd: ''
                }
              )
            } else {
              this.setState({ resetProcessing: false, pwd: '' })
              this.setState({ error: res.Msg, errorColor: 'red' })
            }
          })
          .catch(err => {
            console.log(err)
            this.setState({ resetProcessing: false, pwd: '' })
            this.setState({ error: 'Network Error' })
          })
      } else {
        this.setState(
          {
            error: 'Please Enter a Valid Email Address',
            errorColor: 'red',
            pwd: ''
          }

        )
        this.setState({ resetProcessing: false })
      }
    } else {
      this.setState(
        {
          error: 'Please enter the email address',
          errorColor: 'red',
          pwd: ''
        }

      )
      this.setState({ resetProcessing: false })
    }
  }

  render () {
    const { errorColor, email, pwd, error, processing, resetProcessing, isActive } = this.state
    fetch(`${process.env.REACT_APP_API_URL}/api/login/GetIsApplicationActive`)
      .then(res => res.text())
      .then(res => {
        if (res) {
          this.setState({ isActive: res })
        }
      })
    if (isActive === 'true') {
      return (
        <div id="mainContainer">
          <div id="designBorder"></div>
          <img src={logo} className="center main-logo"></img>
          <div id="main-page" >
            <p
              style={{
                color: errorColor
              }}>
              { error}
            </p>
            <div>
              <div>
                <InputRow
                  rowName="Email Address"
                  name="email"
                  value={ email}
                  onChange={(val) => this.setState({ email: val })}
                  required="*"

                />
                <InputRow
                  rowName="Password"
                  name="password"
                  value={ pwd}
                  onChange={(val) => this.setState({ pwd: val })}
                  required="*"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.handleLogin()
                    }
                  }}
                />
              </div>
            </div>
            <button className="save" onClick={this.handleLogin} disabled={processing}>
              {processing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }}/> : 'Login'}
            </button>
            <button className="save" onClick={this.resetPassword} disabled={resetProcessing}>
              {resetProcessing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }}/> : 'Reset Password'}
            </button>
            <p>If you don&apos;t have an account, <cite><Link className="links" to="/signup">Create</Link></cite></p>
            <p><b>Important:</b> Please note that this password will be used to access your application</p>
          </div>

        </div>

      )
    } else {
      return (
        <div id="mainContainer">
          <div id="designBorder"></div>
          <img src={logo} className="center main-logo"></img>
          <div id="main-page" >
            <p
              style={{
                color: errorColor
              }}>
              { error}
            </p>
            <div>

            </div>

            <p><b>The application form is not available at this time , please check back later</b></p>
          </div>

        </div>

      )
    }
  }
}
LoginPage.propTypes = {
  onLogin: PropTypes.func.isRequired,
  history: PropTypes.object
}
